/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import firebase from 'firebase/app';
import { catchError, map } from 'rxjs/operators';

import { URL_ASSETS } from 'src/app/shared/const';
import { resourcesImages } from 'src/app/shared/const/images-resources';
import { UpdateAdminDto } from 'src/app/shared/dto/admin/update-admin.dto';
import { UpdateAdminGQL } from 'src/app/shared/graphql';
import { AuthService, ProblemsInterceptorService, ThememodeService } from 'src/app/shared/services';
import { environment } from 'src/environments/environment';
import { TelemetryService } from '../shared/services/telemetry.service';

@Component({
  selector: 'app-login-nyc',
  templateUrl: './login-nyc.component.html',
  styleUrls: ['./login-nyc.component.scss']
})
export class LoginNycComponent implements  AfterViewInit {

  submited = false;
  loading = false;
  nycSubmited = false;
  isLight!: boolean;
  userUrl = environment.userPortalURL+'/login-nyc';
  resources!: Array<any>;
  districtId!: string;
  tokenParam!: string;
  params!: any;

  constructor(private authService: AuthService, private activatedRoute: ActivatedRoute,
    private thememodeService: ThememodeService,
    private updateAdminGQL: UpdateAdminGQL, private problemInterceptor: ProblemsInterceptorService, private telemetryService: TelemetryService) {
    this.thememodeService.load('v2');
    this.isLight = this.thememodeService.getColorScheme() !== 'dark';
    this.resources = [
      URL_ASSETS + resourcesImages['itopia-logo-dark'],
      URL_ASSETS + resourcesImages['nyc'],
    ];
    this.params = this.activatedRoute?.snapshot?.queryParams;
    this.districtId = this.params?.districtId;

    this.nycSubmited = sessionStorage.getItem('nyAuth') === 'true';
  }

  ngAfterViewInit(): void {
     this.authService.deleteStItems();    
  }

  updateAdmin(): void {
    this.updateAdminGQL.mutate()
      .pipe(
        map(({ data }) => {
          const result = data as UpdateAdminDto;
          if (result?.data?.updateAdmin?.problem) {
            this.problemInterceptor.intercept(result?.data?.updateAdmin?.problem);
          }
        }),
        catchError((error) => {
          this.problemInterceptor.interceptError(error);
          return error;
        })
      ).subscribe();
        const processId = this.telemetryService.generateProcessId();
      sessionStorage.setItem('processId', processId);
  }

  signInWithNyc(): void {
    this.nycSubmited = true;
    this.loading = true;
    sessionStorage.setItem('signInRedirect', 'true');
    sessionStorage.setItem('nycAuth', "true");

    const authorizationUrl = new URL(environment.nycAuthUrl);
    authorizationUrl.searchParams.set('client_id', environment.nycClientId);
    authorizationUrl.searchParams.set('response_type', 'code');
    authorizationUrl.searchParams.set('scope', 'openid profile email');
    authorizationUrl.searchParams.set('redirect_uri', `${environment.apiURL}/auth/nyc?login=admin`);

    // Request an Authorization Token
     window.location.assign(authorizationUrl.toString());
  }

  goToStudentPortal(): void {
     window.open(this.userUrl, '_blank');
  }
}
